













































































































































































































































































import { Vue, Component, Prop } from "vue-property-decorator";
import { Action, State } from "vuex-class";
import Dependants from "../Dependants.vue";
import Callback from "../Call/Callback.vue";
import { User } from "@/types";
import logger from "@/configs/logger";

@Component({ components: { Dependants, Callback } })
export default class PersonalDetails extends Vue {
  @Prop({ required: true }) lead!: any;
  @Action("updateLead") updateLead!: Function;
  @Action("getDispositions") getDispositions!: Function;
  @State("user") user!: User;
  @State("taskAttributes") taskAttributes!: any;

  leadUpdates: any = {};
  dispositions = [];

  async mounted() {
    this.dispositions = await this.getDispositions();
  }

  get dispositionValues() {
    return this.dispositions.map((val: any) => val.name);
  }

  get usaStates(): any[] {
    const UsaStates = require("usa-states").UsaStates;
    return new UsaStates().states;
  }

  get isAdmin() {
    return this.user.roles.includes("admin");
  }

  get attributes(): any {
    return this.taskAttributes || {};
  }

  get beforeDisposition(): boolean {
    return this.attributes.call_ended;
  }

  async submitLeadUpdate(notify = false) {
    const leadSourceIncluded = Object.keys(this.leadUpdates).includes(
      "lead_source"
    );

    if (leadSourceIncluded) {
      if (this.isAdmin) {
        try {
          await this.updateLead({
            data: this.leadUpdates,
            leadId: this.lead.id,
            notify
          });
          // this.loadLeads(); call function here
        } catch (error) {
          logger("error", "lead update error", error);
        }
      } else {
        this.$toasted
          .error("Lead Sources can only be updated by admins.")
          .goAway(2000);
      }
    } else {
      this.updateLead({ data: this.leadUpdates, leadId: this.lead.id, notify });
    }
  }

  handleInputChange(key: string, val: string) {
    if (!val || !key) return;
    this.leadUpdates[key] = val;
  }
}
